import { gozokiApiWithAuth } from '../gozokiApi'

export interface PreProjectResponse {
  id: number
  forecastYear: number
  openingsCount: number
}

export interface PreProjectCityResponse {
  id: number
  name: string
  latitude: number | null
  longitude: number | null
  postalCode: string | null
  departmentCode: string | null
  departmentName: string | null
  preProjects: PreProjectResponse[]
}

export const fetchPreProjectCities = async () => {
  const response = await gozokiApiWithAuth.get<PreProjectCityResponse[]>('/pre-project-cities')
  return response.data
}
